import React from 'react';
import { navigationClickEvent } from 'analytics/events/studio';

import { routes } from 'constants/routes';

import { getSanityLinkUrl } from 'shared/utils/getSanityLinkUrl';

import FooterSocial from '../FooterSocial/FooterSocial';
import FooterCopyright from '../FooterCopyright/FooterCopyright';
import FooterLogo from '../FooterLogo/FooterLogo';
import { useFooterContext } from '../FooterContext';

import styles from './styles.module.scss';
import { usePageContext } from '@portal/processes/Page/PageContext';

const FooterLogoSection = () => {
  const {
    data: { accessibilityLogoLabel },
    footerSettings
  } = useFooterContext();

  const { isAgzPage } = usePageContext();

  const logoClickEventSend = () =>
    navigationClickEvent({
      location: 'footer_logo',
      navigationType: 'link'
    });

  const footerLogoLink =
    footerSettings?.hasDifferentLinks && footerSettings?.logoLink
      ? getSanityLinkUrl(footerSettings.logoLink) || routes.websiteRoot
      : routes.websiteRoot;

  return (
    <div className={styles.root}>
      <div className={styles.social}>
        <FooterSocial />
      </div>
      <a
        href={footerLogoLink}
        aria-label={accessibilityLogoLabel}
        className={styles.logoLink}
        onClick={logoClickEventSend}>
        <FooterLogo isAGZ={isAgzPage} />
      </a>
      <span className={styles.copyright}>
        <FooterCopyright />
      </span>
    </div>
  );
};

export default FooterLogoSection;
